import React from 'react';
import { SFSubscriptionProduct } from 'pages/api/account/subscriptions';
import classnames from 'utils/classnames';
import { stringToCurrency } from 'utils/currency';
import BCImage from 'components/BcImage';
import HorizontalLine from 'components/ui/HorizontalLine';
import BinIcon from 'components/icons/BinIcon';
import UnitArrowDownIcon from 'components/icons/UnitArrowDownIcon';
import UnitArrowUpIcon from 'components/icons/UnitArrowUpIcon';

type SubscriptionOrderProps = {
  product: SFSubscriptionProduct;
  editable: boolean;
  canDelete: boolean;
  moreItem?: () => void;
  lessItem?: () => void;
  removeItem?: () => void;
};

const SubscriptionOrder: React.FC<SubscriptionOrderProps> = (props) => {
  const { product, editable, canDelete, moreItem, lessItem, removeItem } = props;

  const orderStyle = classnames({
    ' opacity-40': !editable,
  });

  return (
    <>
      <div className="text-sf-blue-700">
        <HorizontalLine />
        <div className={`relative w-full py-6 ${orderStyle}`}>
          <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
            <div className="relative w-full md:w-auto">
              <div className={` overflow-hidden rounded-md`}>
                <div className="relative w-full md:hidden">
                  <BCImage {...product?.image} className="" layout="responsive" objectFit="cover" />
                </div>
                <div className="relative hidden md:block md:h-[148px] md:w-[148px]">
                  <BCImage {...product?.image} className="" layout="fixed" objectFit="cover" />
                </div>
              </div>
            </div>
            <div className="flex w-full flex-col gap-y-1.5">
              <div
                className={`relative flex w-full items-center justify-between gap-x-6 text-sf-blue-700 `}
              >
                <div>
                  <p className={`mb-4 text-base font-medium`}>{product?.name}</p>
                </div>
                {editable && canDelete && (
                  <div onClick={removeItem} className={'cursor-pointer'}>
                    <BinIcon className={'mb-4'} />
                  </div>
                )}
              </div>
              <div className="relative w-full">
                <p className={`text-xs text-sf-blue-700 `}>
                  {product?.minWeight} | {stringToCurrency(product?.price.toString(), ``)}
                </p>
              </div>
              <div className="relative w-full">
                <p className={`text-sm font-medium text-sf-blue-700 `}>
                  {stringToCurrency(product?.total?.toString(), ``)}
                </p>
              </div>
              <div
                className={`relative flex w-full items-center justify-center rounded-md border border-sf-blue-700 md:max-w-[200px] `}
              >
                <div>
                  <button
                    className="px-7 py-6 text-opacity-5"
                    onClick={lessItem}
                    disabled={!editable}
                  >
                    <UnitArrowDownIcon />
                  </button>
                </div>
                <div className="flex w-full items-center justify-center">
                  <div>
                    <span className={`text-sm font-medium`}>
                      {`${product?.quantity} unit${product?.quantity > 1 ? `s` : ``}`}
                    </span>
                  </div>
                </div>
                <div>
                  <button className="px-7 py-6" onClick={moreItem} disabled={!editable}>
                    <UnitArrowUpIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionOrder;
